import {getSortedData}  from "../../../components_v2/List/helper";
export const getSortedProjects = ({ projects, sort }) => {
    return getSortedData({ data: projects, sort })
}
